
/**
 * setCanvasScrollability()
 *
 * Function that takes the height of the page and applies it to the .canvas element.
 * Overflow hidden is set on that element, restricting the ability to scroll. This
 * is intended to be used when the off-canvas menu is opened, and so focusing interaction
 * in that menu.
 *
 * Improvements?
 * Potentially could add a transparent overlay over the canvas element to disable
 * interaction entirely when the off-canvas menu is opened.
 *
 */



function setCanvasScrollability() {
  var windowHeight = $(window).height();

  if ( $('body').hasClass('off-canvas--open') ) {
    $('.canvas').css({
      'height': windowHeight+'px',
      'overflow': 'hidden'
    });
    $('.draw-btn').addClass("arrow-btn");
  } else {
    $('.canvas').removeAttr('style');
    $('.draw-btn').removeClass("arrow-btn");
  }
};



/**
 * offCanvasToggle()
 *
 * Simple toggle for off-canvas menu, which applies the off-canvas--open class
 * to the body element. CSS styles take over from there, including handling the
 * animations. This will also run setCanvasScrollability() to update the canvas
 * height.
 */

function offCanvasToggle() {

  $('.offcanvas').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('off-canvas--open');
    setCanvasScrollability();
  });

  $(window).resize( function () {
    if ($(window).width() >= 700 )  {
      $('body').removeClass('off-canvas--open');
      $('.canvas').removeAttr('style');
      $('.draw-btn').removeClass("arrow-btn");
    }
  });

};

/**
 * initializeAccordion()
 *
 * Sets the initial state of accordion elements on page load. The
 * basic structure of accordion elements are set up with data- attributes.
 * It might look something like this:
 *
 * <section data-accordion="ID">
 *   <header>
 *     <h1><a data-accordion href="">Accordion Link</a></h1>
 *   </header>
 *   <div data-accordion-body="ID">
 *     ..
 *   </div>
 * </section>
 *
 * The 'data-accordion' attribute has a value [ID] that must be matched
 * with the 'data-accordion-body'. The link that controls the accordion
 * is a link with the 'data-accordion' attribute. A value here is unnecessary.
 *
 * This accordion will close any panels before opening a new panel. It will also
 * configure to the height of the viewport, so that all panels and the links that
 * go along with them are always visible on screen. This, obviously, has a limit
 * as too many panels would cause this pattern to break.
 *
 * Improvement?
 * Develop a way to configure the accordion also work without the 'close one open one'
 * model. Develop safegurades into the script in case of too many panels.
 */

function initializeAccordion() {

  var accordionEl = $('[data-accordion]'),
    initAttr = 'data-accordion-initstatus',
    openString = 'open',
    menuOpenString = 'menu-is-open';

  // cylcle through accordion sections
  accordionEl.each(function() {
    var thisAccordionBody = $(this).find('[data-accordion-body]');

    // if accordion section is set to open, keep open
    if ( $(this).attr(initAttr) === openString ) {
      $(this)
        .addClass(menuOpenString);
      thisAccordionBody
        .show()
    }
    // if not, keep it closed and remove any classes.
    else {
      thisAccordionBody
        .hide()
        .removeClass(menuOpenString);
    }
  });
};

/**
 * accordionToggle()
 *
 * This toggle function closes and opens panels for the accordion. See the
 * documentation for the initializeAccordion() function for the mark-up pattern.
 * This function will loop through all accordion panels on click and determine if
 * there are any panels already open that do not match the target panel. It closes
 * those panels, if there are any, and then opens the target panel.
 */

function accordionToggle() {

  $('[data-accordion]').find('a[data-accordion]').click(function(e){

    var thisParent = $(this).parents('[data-accordion]'),
        thisId = $(this).parents('[data-accordion]').attr('data-accordion'),
        thisBody = $('[data-accordion-body='+thisId+']');

    e.preventDefault();

    $('[data-accordion-body]').each(function() {
      if ( $(this).is(':visible') && $(this).parents('[data-accordion]').attr('data-accordion') != thisId ) {
        $(this).slideUp('fast');
        $(this).parents('[data-accordion]').removeClass('menu-is-open');
      }
    });

    thisParent
      .toggleClass('menu-is-open');

    thisBody
      .slideToggle('fast');

  });

}

/**
 * setBodyHeight(tune)
 *
 * This function determines the body height of accordion elements. The
 * target height is the height of the viewport minus the height of the
 * height of the remaining unopen accordion panels. There is also the option
 * add a tuning value to this number that will add a certain height to the
 * 'unopen' panels. This value is added to each unopen accordion panels as
 * the script looks through them. For example, if the tune value is 1 and there are 3
 * total panels, the value of the tune will be 3.
 *
 *
 */

function setBodyHeight(tune) {
  var windowHeight = $(window).height(),
      singleHeaderHeight = $('[data-accordion] > header').height(),
      totalHeaderHeight = 0,
      bodyHeight = 0;


  $('[data-accordion-header]').each(function() {
    if ( tune > 0 ) {
      totalHeaderHeight = totalHeaderHeight + tune + singleHeaderHeight;
    }
    else {
      totalHeaderHeight = totalHeaderHeight + singleHeaderHeight;
    }
  });

  bodyHeight = windowHeight - totalHeaderHeight;

  $('[data-accordion-body]').css({
    'max-height' : bodyHeight+'px',
    'overflow' : 'auto'
  });

  $('.off-canvas').css('height', windowHeight+'px');

};

/**
 * searchFormToggle()
 *
 * Basic function to toggle a class on click for the search menu.
 */

function searchFormToggle() {

  $('.header--search a').click(function(e) {
    e.preventDefault();

    if ( $(this).attr('data-search') === 'open' ) {
      $(this).parents('.header--search').addClass('search-is-active');
      $('.header--search input').blur();
    }
    else if ( $(this).attr('data-search') === 'close' ) {
      $(this).parents('.header--search').removeClass('search-is-active');
    }
  });

}

$(window).resize(function() {
  setCanvasScrollability();
  setBodyHeight(1);
});

$(document).ready(function(){

  initializeAccordion();
  accordionToggle();
  offCanvasToggle();
  setCanvasScrollability();
  setBodyHeight(1);
  searchFormToggle();

  function addItem(form_id) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#'+form_id).serialize(),
      success: Shopify.onSuccess,
      error: Shopify.onError
    });


  }

  $(".addtocart").click(function(e){

    var elem = $(this)
    $(elem).prop("disabled", true)

    e.preventDefault();
    addItem('add-item-form');

  });




  Shopify.onSuccess = function() {
    // $.ajax({ 
    //   type: 'GET',
    //   url: '/cart.js',
    //   async: false, 
    //   cache: false, 
    //   dataType: 'json',
    //   success: updateCart,
    // });   

    var elem = $('.addtocart');

    elem.removeAttr("disabled");

    var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
  
    function animate() {

        $('#add-to-cart').addClass('added-anim');
        $('#add-to-cart').val('Added!');
        setTimeout(function() {
               $('#add-to-cart').removeClass('added-anim');
               $('#add-to-cart').val('Add to Cart');
        }, 800);

        var cartCount =  parseInt($('#cart-count').text()) + quantity;
        $('#cart-count').text(cartCount);
        $('#cart-count').addClass('pulse-animation');
    }

    animate();
    
    setTimeout(function() {
      location.reload();
    }, 1000);


  };

  // function updateCart(data){
    
  //   var items = (data.items);
  //   var cart = $('.cart-draw tbody');
  //   var cartHTML = $('.cart-draw tbody');
  //   var quantityLabel = $('.qty label').html().replace(':','');


  //   var checkoutRow = $('tr:last-child').html();
  //   var checkoutPastPrice = $('.cart-draw--summary .price .total').html();
  //   //alert(checkoutPastPrice);
  //   checkoutRow.replace(checkoutPastPrice, items.total_price);


  //   for(var key in items) {
  //       //alert(items[key].title);

  //       var cartLine = '<tr class="cart-draw--item cart-draw--'+key+'"'+items[key].id+'""><td class="item"><a href="'+items[key].url+'"><img class="product_image" src="'+items[key].image+'_small"  alt="'+items[key].title+'" /></a>';


  //       if (items[key].variant_title){     
  //           cartLine += '<p class="gamma"><a href="'+items[key].url+'">'+items[key].title+'</a></p>';
  //           cartLine += '<p class="variant_title"><a href="'+items[key].url+'">'+items[key].variant_title+'</a></p></td>';
  //       } else {
  //           cartLine += '<p class="gamma"><a href="'+items[key].url+'">'+items[key].title+'</a></p></td>';
  //       }

  //       cartLine += '<td class="qty"><label for="updates_'+items[key].id+'">'+quantityLabel+':</label><input type="text" size="4" name="updates[]" id="updates_'+items[key].id+'" value="'+items[key].quantity+'" onfocus="this.select();" class="tc item-quantity" /></td>';

  //       cartLine += '<td class="price"><p class="gamma">'+Shopify.formatMoney(items[key].line_price)+'</p></td><td class="remove"><a href="/cart/change?line='+key+'&quantity=0" class="cart beta">&#10005;</a></td></tr>';

  //       cartHTML += cartLine;
  //   } 

  //   cartHTML += checkoutRow;
  //   cart.html(cartHTML); 
  //   $('tr:last-child').addClass('cart-draw--summary');
  //   gradientRows();

  // }

  Shopify.onError = function(XMLHttpRequest, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      alert(data.message + '(' + data.status  + '): ' + data.description);
    } else {
      alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
    }

    $('.addtocart').removeAttr("disabled");
  };

  Shopify.fullMessagesFromErrors = function(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };

});

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
});

jQuery(document).ready(function($){

  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);

//Modal Master
;(function($, window, document, undefined) {
  "use strict";
  /*jshint smarttabs:true*/

  // :focusable expression, needed for tabindexes in modal
  $.extend($.expr[':'],{
    focusable: function(element){
      var map, mapName, img,
        nodeName = element.nodeName.toLowerCase(),
        isTabIndexNotNaN = !isNaN($.attr(element,'tabindex'));
      if ('area' === nodeName) {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
          return false;
        }
        img = $('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
      }

      var result = isTabIndexNotNaN;
      if (/input|select|textarea|button|object/.test(nodeName)) {
        result = !element.disabled;
      } else if ('a' === nodeName) {
        result = element.href || isTabIndexNotNaN;
      }

      return result && visible(element);

      function visible(element) {
        return $.expr.filters.visible(element) &&
          !$(element).parents().addBack().filter(function() {
            return $.css(this,'visibility') === 'hidden';
          }).length;
      }
    }
  });

  var pluginNamespace = 'the-modal',
    // global defaults
    defaults = {
      lockClass: 'themodal-lock',
      overlayClass: 'themodal-overlay',

      closeOnEsc: true,
      closeOnOverlayClick: true,

      onBeforeClose: null,
      onClose: null,
      onOpen: null,

      cloning: true
    };
  var oMargin = {};
  var ieBodyTopMargin = 0;

  function isIE() {
    return ((navigator.appName == 'Microsoft Internet Explorer') ||
      (navigator.userAgent.match(/MSIE\s+\d+\.\d+/)) ||
      (navigator.userAgent.match(/Trident\/\d+\.\d+/)));
  }

  function lockContainer(options, overlay) {
    var body = $('body');
    var oWidth = body.outerWidth(true);
    body.addClass(options.lockClass);
    var sbWidth = body.outerWidth(true) - oWidth;
    if (isIE()) {
      ieBodyTopMargin = body.css('margin-top');
      body.css('margin-top', 0);
    }

    if (sbWidth != 0) {
      var tags = $('html, body');
      tags.each(function () {
        var $this = $(this);
        oMargin[$this.prop('tagName').toLowerCase()] = parseInt($this.css('margin-right'));
      });
      $('html').css('margin-right', oMargin['html'] + sbWidth);
      overlay.css('left', 0 - sbWidth);
    }
  }

  function unlockContainer(options) {
    if (isIE()) {
      $('body').css('margin-top', ieBodyTopMargin);
    }

    var body = $('body');
    var oWidth = body.outerWidth(true);
    body.removeClass(options.lockClass);
    var sbWidth = body.outerWidth(true) - oWidth;

    if (sbWidth != 0) {
      $('html, body').each(function () {
        var $this = $(this);
        $this.css('margin-right', oMargin[$this.prop('tagName').toLowerCase()])
      });
    }
  }

  function init(els, options) {
    var modalOptions = options;

    if(els.length) {
      els.each(function(){
        $(this).data(pluginNamespace+'.options', modalOptions);
      });
    } else {
      $.extend(defaults, modalOptions);
    }

    // on Ctrl+A click fire `onSelectAll` event
    $(window).bind('keydown',function(e){
      if (!(e.ctrlKey && e.keyCode == 65)) {
        return true;
      }

      var selectAllEvent = new $.Event('onSelectAll');
      selectAllEvent.parentEvent = e;
      $(window).trigger(selectAllEvent);
      return true;
    });

    els.bind('keydown',function(e){
      var modalFocusableElements = $(':focusable',$(this));
      if(modalFocusableElements.filter(':last').is(':focus') && (e.which || e.keyCode) == 9){
        e.preventDefault();
        modalFocusableElements.filter(':first').focus();
      }
    });

    return {
      open: function(options) {
        var el = els.get(0),
          localOptions = $.extend({}, defaults, $(el).data(pluginNamespace+'.options'), options);

        // close modal if opened
        if($('.'+localOptions.overlayClass).length) {
          $.modal().close();
        }

        var overlay = $('<div/>').addClass(localOptions.overlayClass).prependTo('body');
        overlay.data(pluginNamespace+'.options', localOptions);

        lockContainer(localOptions, overlay);

        if(el) {
          var openedModalElement = null;
          if (!localOptions.cloning) {
            overlay.data(pluginNamespace+'.el', el);
            $(el).data(pluginNamespace+'.parent', $(el).parent());
            openedModalElement = $(el).appendTo(overlay).show();
          } else {
            openedModalElement = $(el).clone(true).appendTo(overlay).show();
          }
        }

        if(localOptions.closeOnEsc) {
          $(document).bind('keyup.'+pluginNamespace, function(e){
            if(e.keyCode === 27) {
              $.modal().close();
            }
          });
        }

        if(localOptions.closeOnOverlayClick) {
          overlay.children().on('click.' + pluginNamespace, function(e){
            e.stopPropagation();
          });
          $('.' + localOptions.overlayClass).on('click.' + pluginNamespace, function(e){
            $.modal().close();
          });
        }

        $(document).bind('touchmove.'+pluginNamespace,function(e){
          if(!$(e).parents('.' + localOptions.overlayClass)) {
            e.preventDefault();
          }
        });

        if(el) {
          $(window).bind('onSelectAll',function(e){
            e.parentEvent.preventDefault();

            var range = null,
              selection = null,
              selectionElement = openedModalElement.get(0);
            if (document.body.createTextRange) { //ms
              range = document.body.createTextRange();
              range.moveToElementText(selectionElement);
              range.select();
            } else if (window.getSelection) { //all others
              selection = window.getSelection();
              range = document.createRange();
              range.selectNodeContents(selectionElement);
              selection.removeAllRanges();
              selection.addRange(range);
            }
          });
        }

        if(localOptions.onOpen) {
          localOptions.onOpen(overlay, localOptions);
        }
      },
      close: function(options) {
        var el = els.get(0),
          localOptions = $.extend({}, defaults, $(el).data(pluginNamespace+'.options'), options);
        var overlay = $('.' + localOptions.overlayClass);

        if ($.isFunction(localOptions.onBeforeClose)) {
          if (localOptions.onBeforeClose(overlay, localOptions) === false) {
            return;
          }
        }

        if (!localOptions.cloning) {
          if (!el) {
            el = overlay.data(pluginNamespace+'.el');
          }
          $(el).hide().appendTo($(el).data(pluginNamespace+'.parent'));
        }

        overlay.remove();
        unlockContainer(localOptions);

        if(localOptions.closeOnEsc) {
          $(document).unbind('keyup.'+pluginNamespace);
        }

        $(window).unbind('onSelectAll');

        if(localOptions.onClose) {
          localOptions.onClose(overlay, localOptions);
        }
      }
    };
  }

  $.modal = function(options){
    return init($(), options);
  };

  $.fn.modal = function(options) {
    return init(this, options);
  };

})(jQuery, window, document);






$(document).ready(function(){

  gradientRows();

  //CART DRAW TOGGLE 
  //Variables
  var cartDraw = $('.cart-draw');
  var cartToggle = $('.cart');
  var cartState = false;
  var cartDrawHeight = cartDraw.height();
  var cartDrawPos = -cartDrawHeight+"px";
  var siteBody = $(".canvas");

  //recapture height on resize
  $( window ).resize(function() {
    var cartDrawHeight = cartDraw.height();
    var cartDrawPos = -cartDrawHeight+"px";
  });

  //position the cart
  cartDraw.css("top", (-cartDrawHeight+"px"));

  //on click, show cart if hidden and slide down page. If not hidden, slide up cart and slide up page.
  cartToggle.click( function () {
    if (cartState == false) {
      cartDraw.css("top", 0 );
      siteBody.css("top", cartDrawHeight);
      cartState = true;
    } else {
      cartDraw.css("top", cartDrawPos );
      siteBody.css("top", 0);
      cartState = false;
    }
  });


 






});

//convert hex to rgb function
function hexToRgb(hex) {
   var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;

    return "rgba(" + r + "," + g + "," + b+ ",x)";
}

function gradientRows(){
  //GRADIENT TABLE ROWS
  //select rows
  var rows = $(".grad-rows tr");

  //grab starting color
  var startColor = $(rows).css("background-color");

  if (startColor.indexOf("#") != -1) {
    //if hex convert to rgb
    startColor = startColor.replace("#", "");
    startColor = hexToRgb(startColor); 
  } else {
    //if not change rgb to rgba to add alpha channel; x=alpha
    startColor = startColor.replace("rgb", "rgba");
    startColor = startColor.replace(")", ", x)");
  }

  //count how many rows there are
  var childrenAmount = $(rows).length;

  //figure out percentage difference for each row
  //minus 1 from length so last row is end color
  var colorSteps = 100/(childrenAmount-1);

  //loop through each row and change background transparency
  $(rows).each(function(i, row) { 
    var alpha = (100 - (colorSteps * i)) / 100;
    var newColor = startColor.replace("x" , alpha);
    //give selected row that new color
    $(row).css("background-color", newColor);

  });

}
 








